import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";
import { getBusinessVehicles } from "../Business/Business";
import { baseUrl, errorTranslate } from "../util";

export const getBusinessListPromise = async () => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  return response.data;
};

export const getBusinessVehiclesPromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/reg-vehicle",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data.map((data) => data.carbon).reduce((a, b) => a + b);
  } else return 0;
};

export const getBusinessOtherVehiclesPromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/stationary-combustion",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data.map((data) => data.carbon).reduce((a, b) => a + b);
  } else return 0;
};

export const getBusinessAirconPromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/refrigerant",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data.map((data) => data.carbon).reduce((a, b) => a + b);
  } else return 0;
};

export const getBusinessIndustrialPromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/industrial-gas",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data.map((data) => data.carbon).reduce((a, b) => a + b);
  } else return 0;
};

export const getBusinessEnergyPromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/external-power",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data.filter((data) => data.category !== "home-produced");
  } else return [];
};

export const getBusinessSuppresantPromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/suppressant",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data.map((data) => data.carbon).reduce((a, b) => a + b);
  } else return 0;
};

export const getBusinessSupplyPromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/supplies/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data.map((data) => data.co2).reduce((a, b) => a + b);
  } else return 0;
};

export const getBusinessWastePromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/waste",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data.map((data) => data.carbon).reduce((a, b) => a + b);
  } else return 0;
};

export const getBusinessTravelPromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/travel",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data.map((data) => data.carbon).reduce((a, b) => a + b);
  } else return 0;
};

export const getBusinessHotelPromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/hotel",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data.map((data) => data.carbon).reduce((a, b) => a + b);
  } else return 0;
};

export const getVehicleCarbon = ({ total, setTotal }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=vehicle",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotal(response.data.data.reduce((acc, obj) => acc + obj.carbon, 0));
    })
    .catch(function (error) {});
};

export const getOtherVehicleCarbon = async ({ total, setTotal }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=stationary-combustion",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotal(response.data.data.reduce((acc, obj) => acc + obj.carbon, 0));
    })
    .catch(function (error) {});
};

export const getAirconCarbon = async ({ total, setTotal }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=refrigerant",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotal(response.data.data.reduce((acc, obj) => acc + obj.carbon, 0));
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getIndustrialCarbon = async ({ total, setTotal }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=industrial-gas",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotal(response.data.data.reduce((acc, obj) => acc + obj.carbon, 0));
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getEnergyCarbon = async ({
  total,
  setHeat,
  setSteam,
  setCooling,
  setElectricity,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=industrial-gas",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setHeat(
        response.data.data.reduce((acc, obj) => {
          if (obj.type == "Heat") return acc + obj.carbon;
          else return acc + 0;
        }, 0)
      );
      setSteam(
        response.data.data.reduce((acc, obj) => {
          if (obj.type == "Steam") return acc + obj.carbon;
          else return acc + 0;
        }, 0)
      );
      setCooling(
        response.data.data.reduce((acc, obj) => {
          if (obj.type == "Cooling") return acc + obj.carbon;
          else return acc + 0;
        }, 0)
      );
      setElectricity(
        response.data.data.reduce((acc, obj) => {
          if (obj.type == "Electricity") return acc + obj.carbon;
          else return acc + 0;
        }, 0)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSuppresantCarbon = async ({ total, setTotal }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=suppressant",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotal(response.data.data.reduce((acc, obj) => acc + obj.carbon, 0));
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSupplyCarbon = async ({ total, setTotal }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=supplies",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotal(response.data.data.reduce((acc, obj) => acc + obj.co2, 0));
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWasteCarbon = async ({ total, setTotal }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=waste",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotal(response.data.data.reduce((acc, obj) => acc + obj.co2, 0));
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getTravelCarbon = async ({ total, setTotal }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=travel",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotal(response.data.data.reduce((acc, obj) => acc + obj.co2, 0));
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getHotelCarbon = async ({ total, setTotal }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=hotel",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotal(response.data.data.reduce((acc, obj) => acc + obj.co2, 0));
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getBusinessTravelCarbon = async ({ total, setTotal }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=travel",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotal(response.data.data.reduce((acc, obj) => acc + obj.co2, 0));
    })
    .catch(function (error) {});
};

export const getCompanyReportInformation = ({
  setName,
  setCVR,
  setAddress,
  setEmail,
  setDate,
  setPreparedBy,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/accounts/me",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setName(
        response.data.data.profile.firstName +
          " " +
          response.data.data.profile.familyName
      );
      setCVR(response.data.data.profile.account.cvr);
      setEmail(response.data.data.profile.email);
      setPreparedBy(
        response.data.data.profile.firstName +
          " " +
          response.data.data.profile.familyName
      );
      // setAddress(response.data.data.address1)
    })
    .catch(function (error) {
      // console.log(error);
    });

  // return ;
};

export const addReportLogo = ({ logo, callback = null, publicId }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const config = {
    method: "post",
    url: baseUrl + "/api/business/report/add-report-logo",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      logo: logo,
      year: year,
      public_id: publicId,
    },
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      if (callback) callback();
    })
    .catch(function (error) {
      updateReportLogo({ logo: logo, publicId: publicId });
    });
};

export const updateReportLogo = ({ logo, publicId, swal = false }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var data = {
    logo: logo,
    year: year,
    public_id: publicId,
  };

  var config = {
    method: "put",
    url: baseUrl + "/api/business/report/update-report-logo",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      if (swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    })
    .catch(function (error) {
      if (swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const getReportLogo = ({ setLogo }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const data = {
    year: year,
  };
  var config = {
    method: "get",
    url: baseUrl + "/api/business/report/get-report-logo",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      if (response.data.logo === "") setLogo("");
      else {
        setLogo(response.data.logo);
      }
    })
    .catch(function (error) {
      if (error.response.status == 404) {
        console.log("No logo found for this user.");
      }
    });
};

export const deleteReportLogo = ({
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/report/delete-report-logo",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: {
      year: year,
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};
